import { InstructorProfileData } from '../../common/interfaces/instructorProfile';
import { ActivityData } from './activity';

export interface ReservedTime {
    start_timestamp: number | null;
    end_timestamp: number | null;
}

export const ValidateInstructorMessages = {
    BOOKED: 'warning_booked',
    QUALIFICATION_LANGUAGE: 'warning_language',
    QUALIFICATION_COUNTRY: 'warning_country',
    QUALIFICATION_COURSE: 'warning_course',
    WEBEX_HOST_LICENSE: 'warning_webex_host_license',
};

export interface ValidateActivityInstructorProfile extends InstructorProfileData {
    activities: Array<[ActivityData, string, boolean]>;
    booked_activities: Array<ActivityData>;
    do_not_shuffle_activities: Array<ActivityData>;
    back_to_back_activities: Array<ActivityData>;
    error_messages: Array<string>;
    warning_messages: Array<string>;
}
